import merge from 'deepmerge';
import { commonI18n } from '@shared';
import hu from './hu';

export default merge(commonI18n, { hu });
